import React, {memo, useCallback, useMemo, useState} from 'react';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import Select from 'react-select';
import {registerPlugin} from 'react-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond/dist/filepond.min.css';
import "jalaali-react-date-picker/lib/styles/index.css";
import ToggleSwitch from "../checkbox/toggle";
import yupPersianValidationErrors from "../../utils/i18n";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import JoditEditor from "jodit-react";
import config from "../../config";
import moment from "moment-jalaali";

registerPlugin(FilePondPluginFileValidateType, FilePondPluginImagePreview);

const DynamicForm = ({
                         fields,
                         meta,
                         onSubmit,
                         submitText = 'ثبت',
                         values = {},
                         successfulSubmitText = 'با موفقیت انجام شد',
                         showPostLink = false,
                         showPreviewButton = false,
                         previewOnClick = null
                     }) => {
    console.log('dynamic form loaded')
    const [loading, setLoading] = useState(false);
    const [previewLoading, setPreviewLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    Yup.setLocale(yupPersianValidationErrors);

    const previewOnSubmit = async () => {
            setPreviewLoading(true);
            try {
                values = formik.values
                await previewOnClick({...values, files: null});
                // if (successfulSubmitText) {
                //     setMessage(successfulSubmitText);
                // }
                // setErrorMessage();
            } catch (error) {
                // setErrorMessage(`خطا در ثبت:  ${error}`);
                // if (error.response?.data?.errors) {
                //     formik.setErrors(error.response.data.errors);
                // }
            } finally {
                setPreviewLoading(false);
            }
        }

    const initiateValues = () => {
        fields.reduce((acc, field) => {
            // acc[field.fieldName] = values[field.fieldName] || (field.type === 'file' ? [] : '');
            acc[field.fieldName] = values[field.fieldName] || '';
            return acc;
        }, {})
    }

    const joditConfig = useMemo(() => ({
        uploader: {
            language: "fa",
            direction: "rtl",
            defaultMode: "1",
            defaultActionOnPaste: "insert_clear_html",
            insertImageAsBase64URI: false, // Don't insert as base64, we want a URL
            withCredentials: true,
            url: `${config.baseURL}/news/upload-image/`, // Set your endpoint here
            prepareData: function (formData) {
                let file = formData.getAll('files[0]')[0]
                formData.append('image', file)
                formData.delete('files[0]')
                formData.delete('path')
                formData.delete('source')

                return formData
            },
            process: function (resp) {
                const obj = {
                    files: [resp?.data?.result?.url] ?? [],
                    path: resp?.data?.result?.url,
                    baseurl: resp?.data?.result?.url,
                    error: resp.data?.error ?? 'Error',
                    msg: resp.data?.detail ?? 'ERROR',
                }
                console.log('res, obj', resp, obj)
                return obj;
            },
            isSuccess: function (resp) {
                console.log('sucess', resp.success, resp.success ?? true)
                return resp.data.success ?? true
                return true;
            },
            getMessage: function (resp) {
                console.log('message')
                return 'message';
            },
            handlerError: () => {
                console.log('handler error')
            }, defaultHandlerError: () => {
                console.log('default handler error')
            }, handlerSuccess: () => {
                console.log('handler sucess')
            }, defaultHandlerSuccess: function (data, resp) {
                console.log('response', resp)
                console.log('data', data)
                console.log('this', this)
                var i,
                    field = 'files';
                if (data[field] && data[field].length) {
                    for (i = 0; i < data[field].length; i += 1) {
                        this.selection.insertImage(data.baseurl, null, 300, null, 250);
                    }
                }
            },
        }
    }), []);

    const formik = useFormik({
        initialValues: fields.reduce((acc, field) => {
            acc[field.fieldName] = values[field.fieldName] || (field.type === 'file' ? '' : '');
            return acc;
        }, {}),
        validate: useCallback((values) => {
            const errors = {};
            fields.forEach((field) => {
                if (field.validation) {
                    const result = field.validation(values[field.fieldName], values);
                    if (result instanceof Yup.ValidationError) {
                        errors[field.fieldName] = result.message;
                    } else if (typeof result === 'string') {
                        errors[field.fieldName] = result;
                    } else if (result?.validateSync) {
                        try {
                            result.validateSync(values[field.fieldName]);
                        } catch (error) {
                            errors[field.fieldName] = error.message;
                        }
                    }
                }
            });
            return errors;
        }, [fields]),
        onSubmit: async (values) => {
            setLoading(true);
            try {
                await onSubmit({...values, files: null});
                if (successfulSubmitText) {
                    setMessage(successfulSubmitText);
                }
                setErrorMessage();
            } catch (error) {
                setErrorMessage(`خطا در ثبت:  ${error}`);
                if (error.response?.data?.errors) {
                    formik.setErrors(error.response.data.errors);
                }
            } finally {
                setLoading(false);
            }
        },
    });
    // debugger;
    console.log(formik.values)

    return (
        <form
            onSubmit={formik.handleSubmit}
        >
        {showPostLink && (
            <div></div>
            )}
            <div
                className={`my-4 grid lg:grid-cols-${meta.gridColumns?.large || 3} md:grid-cols-${meta.gridColumns?.medium || 3} grid-cols-${meta.gridColumns?.small || 3} gap-4`}>
                {fields.map((field) => (
                    <div key={field.fieldName}
                         className={`mb-4 col-span-full ${field.colSpan ? `md:col-span-${field.colSpan}` : 'md:col-span-1'}`}>
                        <label className="text-sm dark:text-white ml-3 font-bold">{field.title}</label>

                        {/* Render field based on type */}
                        {field.type === 'string' || field.type === 'number' ? (
                            <input
                                type={field.type === 'number' ? 'number' : 'text'}
                                id={field.fieldName}
                                value={formik.values[field.fieldName]}
                                onChange={(value) => {
                                    console.log('before onChaneg', value.target.value)
                                    if (field.onChange) {
                                        value = field.onChange(value)
                                    }
                                    console.log('after onChagne', value)
                                    formik.handleChange(value)
                                }}
                                onBlur={formik.handleBlur}
                                className="w-full p-2 border rounded-lg"
                            />
                        ) : field.type === 'dropdown' ? (
                            <select
                                id={field.fieldName}
                                value={formik.values[field.fieldName]}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                className="w-full p-2 border rounded-lg"
                            >
                                {field.options.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                        ) : field.type === 'selectbox' ? (
                            <Select
                                id={field.fieldName}
                                options={field.options}
                                value={formik.values[field.fieldName]}
                                onChange={(option) => formik.setFieldValue(field.fieldName, option)}
                                // onChange={(option) => console.log(option)}
                                onBlur={formik.handleBlur}
                                className="w-full"
                                isRtl
                                placeholder="انتخاب کنید"
                            />
                        ) : field.type === 'file' ? (
                            <div
                                className="flex bg-white flex-col lg:flex-row gap-4 justify-between p-2 lg:px-6 items-center border rounded-xl">
                                <div className="w-full lg:w-1/2 order-2 lg:order-1">
                                    <input
                                        ref={formik.values[field.fieldName].ref || field.ref}
                                        accept={field.accept || 'image/*'}
                                        id={`image-upload-${field.fieldName}`}
                                        type="file"
                                        onChange={(event) => {
                                            const file = event.target.files[0];
                                            if (file) {
                                                formik.setFieldValue(field.fieldName, {
                                                    file,
                                                    url: URL.createObjectURL(file),
                                                });
                                            }
                                        }}
                                        className="hidden"
                                    />
                                    <button
                                        onClick={() => {
                                            console.log('clicked', field?.ref)
                                            if (field?.ref) {
                                                field.ref.current.click();
                                            }
                                        }}
                                        className="flex items-center flex-col w-full h-full justify-center px-4 py-2 bg-blue-700 hover:bg-blue-800 text-white font-semibold rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75"
                                        type="button"
                                    >
                                        {!formik.values[field.fieldName]?.url
                                            ? (formik.values[field.fieldName] && formik.values[field.fieldName] instanceof String ?
                                                <p className="text-gray-300">{formik.values[field.fieldName]?.url}</p> : 'انتخاب عکس')
                                            : <p className="text-gray-300">{formik.values[field.fieldName]?.url}</p>}
                                    </button>
                                </div>
                                <div className="bg-gray-600 order-1 lg:order-2 w-full h-36 lg:w-40 rounded-xl">
                                    <img
                                        className={`w-full h-full rounded-xl ${formik.values[field.fieldName] ?? formik.values[field.fieldName]?.url ? '' : 'hidden'}`}
                                        src={formik.values[field.fieldName]?.url ?? formik.values[field.fieldName]}
                                        alt="Preview"
                                    />
                                </div>
                            </div>
                        ) : field.type === 'text-editor' ? (
                            <div className="py-4 rounded-lg">
                                <JoditEditor
                                    value={formik.values[field.fieldName]}
                                    onChange={(value) => formik.setFieldValue(field.fieldName, value)}
                                    config={joditConfig}
                                />
                            </div>
                        ) : field.type === 'checkbox' ? (
                                <div className="flex items-center justify-center align-middle">
                                    <ToggleSwitch
                                        value={formik.values[field.fieldName] || false}
                                        onChange={(value) => formik.setFieldValue(field.fieldName, value)}
                                    />
                                </div>
                            ) :
                            field.type === 'datepicker' ? (
                                <div>
                                    <div className='w-full'>
                                        <DatePicker
                                            value={formik.values[field.fieldName] || null}
                                            onChange={(value) => formik.setFieldValue(field.fieldName, value.format('YYYY-MM-DD HH:mm:ss'))}
                                            format="YYYY-MM-DD HH:mm:ss"
                                            calendar={persian}
                                            locale={persian_fa}
                                            className="w-full p-2 border rounded-lg"
                                            inputClass="w-full p-2 border rounded-lg"
                                            containerClassName="w-full"
                                            plugins={[
                                                <TimePicker position="bottom"/>
                                            ]}
                                        />
                                    </div>
                                </div>
                            ) : field.type === 'custom' && field.template ? (
                                field.template(formik, field.fieldName)
                            ) : null
                        }

                        {/* Display error message */
                        }
                        {
                            formik.touched[field.fieldName] && formik.errors[field.fieldName] && (
                                <div className="text-red-600 text-sm mt-1">{formik.errors[field.fieldName]}</div>
                            )
                        }
                    </div>
                ))}


                {/* Display messages */
                }
                {
                    errorMessage && <div className="text-red-500 mt-4 col-span-3">{errorMessage}</div>
                }
                {
                    message && <div className="text-green-500 mt-4 col-span-3">{message}</div>
                }
            </div>
            <div className='flex flex-row gap-4'>
            <button
                type="submit"
                className="bg-blue-500 hover:bg-blue-600 text-white p-3 rounded-lg px-16 flex justify-self-start"
                disabled={loading}
            >
                {loading ? 'صبر کنید...' : submitText}
            </button>
            {showPreviewButton && (<button
                className="bg-blue-500 hover:bg-blue-600 text-white p-3 rounded-lg px-16 flex justify-self-start"
                disabled={previewLoading}
                onClick={previewOnSubmit}
            >
                {previewLoading ? 'صبر کنید...' : 'پیش نمایش'}
            </button>)}
            </div>
        </form>
    )
        ;
};

export default memo(DynamicForm);
